import Type from "@/model/types/Type";

const type = {
    M: "m",
    M2: "m²",
    M3: "m³",
    L: "L",
    ML: "ml",
    UNITY: "un",
    KG: "kg",
    T: "t",
    VB: "Vb",
    MONTH: "Mês",
}

const list = [
    {
        value: "",
        text: "Não especificar",
    },
    {
        value: type.M,
        text: type.M,
    },
    {
        value: type.M2,
        text: type.M2,
    },
    {
        value: type.M3,
        text: type.M3,
    },
    {
        value: type.L,
        text: type.L,
    },
    {
        value: type.ML,
        text: type.ML,
    },
    {
        value: type.UNITY,
        text: type.UNITY,
    },
    {
        value: type.KG,
        text: type.KG,
    },
    {
        value: type.T,
        text: type.T,
    },
    {
        value: type.VB,
        text: type.VB,
    },
    {
        value: type.MONTH,
        text: type.MONTH,
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}